"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderLayout = void 0;
var _react = require("react");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _SliderLayout = require("./SliderLayout.styles");
var _css = require("@emotion/css");
var _jsxRuntime = require("react/jsx-runtime");
const SliderLayout = props => {
  const {
    items = [],
    index = 2,
    children
  } = props;
  const {
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const styles = (0, _SliderLayout.useStyles)(props);
  const [currentIndex, setCurrentIndex] = (0, _react.useState)(null);
  const [inIndex, setInIndex] = (0, _react.useState)(null);
  const [outIndex, setOutIndex] = (0, _react.useState)(null);
  const [containerStyle, setContainerStyle] = (0, _react.useState)({});
  const [inStyle, setInStyle] = (0, _react.useState)({});
  const [outStyle, setOutStyle] = (0, _react.useState)({});
  const currentSlideRef = (0, _react.useRef)(null);
  const inSlideRef = (0, _react.useRef)(null);
  const outSlideRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    const newIndex = items.length === 0 ? null : index < 0 ? 0 : index >= items.length ? items.length - 1 : index;
    if (newIndex === null) {
      setCurrentIndex(null);
      setInIndex(null);
      setOutIndex(null);
      setContainerStyle({});
      setInStyle({});
      setOutStyle({});
    } else if (currentIndex === null && inIndex === null) {
      setCurrentIndex(newIndex);
      setInIndex(null);
      setOutIndex(null);
      setContainerStyle({});
      setInStyle({});
      setOutStyle({});
    } else if (currentIndex !== null && currentIndex !== newIndex) {
      setCurrentIndex(null);
      setInIndex(newIndex);
      setOutIndex(currentIndex !== null ? currentIndex : inIndex);
      setTimeout(() => {
        setCurrentIndex(newIndex);
        setInIndex(null);
        setOutIndex(null);
        setContainerStyle({});
        setInStyle({});
        setOutStyle({});
      }, 500);
    }
  }, [currentIndex, inIndex, index, items.length]);
  (0, _react.useEffect)(() => {
    if (currentIndex !== null && currentSlideRef && currentSlideRef.current) {
      setContainerStyle((0, _css.css)({}));
      setInStyle((0, _css.css)({}));
      setOutStyle((0, _css.css)({}));
    }
  }, [currentSlideRef, currentIndex]);
  (0, _react.useEffect)(() => {
    if (inIndex !== null && outIndex !== null && inSlideRef && inSlideRef.current && outSlideRef && outSlideRef.current) {
      const animateDirection = direction === 'rtl' && inIndex > outIndex || direction !== 'rtl' && inIndex <= outIndex ? 'right' : 'left';
      setContainerStyle((0, _css.css)({
        width: outSlideRef.current.clientWidth,
        height: outSlideRef.current.clientHeight,
        overflow: 'hidden',
        transition: 'width 0s ease-in-out, height 0s ease-in-out'
      }));
      setInStyle((0, _css.css)({
        opacity: 0,
        right: animateDirection === 'right' ? '100%' : 'unset',
        left: animateDirection === 'right' ? 'unset' : '100%'
      }));
      setOutStyle((0, _css.css)({
        opacity: 1,
        left: animateDirection === 'right' ? '0%' : 'unset',
        right: animateDirection === 'right' ? 'unset' : '0%'
      }));
      setTimeout(() => {
        setContainerStyle((0, _css.css)({
          width: inSlideRef.current.clientWidth,
          height: inSlideRef.current.clientHeight,
          overflow: 'hidden',
          transition: 'width .5s ease-in-out, height .5s ease-in-out'
        }));
        setInStyle((0, _css.css)({
          opacity: 1,
          right: animateDirection === 'right' ? '0%' : 'unset',
          left: animateDirection === 'right' ? 'unset' : '0%'
        }));
        setOutStyle((0, _css.css)({
          opacity: 0,
          left: animateDirection === 'right' ? '100%' : 'unset',
          right: animateDirection === 'right' ? 'unset' : '100%'
        }));
      }, 1);
    }
  }, [inSlideRef, outSlideRef, inIndex, outIndex, direction]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `${styles['cc-SliderLayout']} ${containerStyle}`,
    "data-index": currentIndex,
    children: [items.map((item, i) => {
      if (i === currentIndex) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "data-index": i,
          ref: currentSlideRef,
          className: `${styles['cc-SliderLayout__item']} ${styles['cc-SliderLayout__item--current']}`,
          children: item
        }, `cc-sliderLayout-slide--${i}`);
      } else if (i === inIndex) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "data-index": i,
          ref: inSlideRef,
          className: `${styles['cc-SliderLayout__item']} ${styles['cc-SliderLayout__item--in']} ${inStyle}`,
          children: item
        }, `cc-sliderLayout-slide--${i}`);
      } else if (i === outIndex) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "data-index": i,
          ref: outSlideRef,
          className: `${styles['cc-SliderLayout__item']} ${styles['cc-SliderLayout__item--out']} ${outStyle}`,
          children: item
        }, `cc-sliderLayout-slide--${i}`);
      } else {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "data-index": i,
          "aria-disabled": true,
          "aria-hidden": true,
          tabIndex: -1,
          className: `${styles['cc-SliderLayout__item--hidden']}`,
          children: item
        }, `cc-sliderLayout-slide--${i}`);
      }
    }), children]
  });
};
exports.SliderLayout = SliderLayout;